import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import * as Util from '../../../common/utilities';

import { Button, Modal } from '@salesforce/design-system-react';

import { ContentBuilderList } from '../';

class ContentBuilderModal extends Component {
  constructor(props) {
    super(props);
    this.modalName = 'contentBuilder';
  }

  componentDidUpdate(prevProps) {
    if (
      Util.propChanged(
        prevProps,
        this.props,
        'modals.contentBuilder.isOpen',
        true
      )
    ) {
      this.props.actions.searchContentBuilder();
    }
  }

  handleContentSelect(event, selection) {
    const selectedAsset = selection.selection[0];
    if (!selectedAsset.disabled) {
      this.props.actions.updateModal(this.modalName, { selectedAsset });
    }
  }

  handleSelect() {
    const selectedAsset = this.props.modals[this.modalName]?.data
      ?.selectedAsset;
    if (selectedAsset) {
      this.props.onSelect(selectedAsset);
    }
  }

  renderModal() {
    const selectedAsset = this.props.modals[this.modalName]?.data
      ?.selectedAsset;
    return (
      <ContentBuilderList
        actions={this.props.actions}
        contentBuilder={this.props.contentBuilder}
        rowSelectionMode="radio"
        onContentSelect={this.handleContentSelect.bind(this)}
        selectedContent={selectedAsset}
      />
    );
  }

  renderFooter() {
    const { formatMessage } = this.props.intl;

    /**
     * Cancel
     */
    const cancelLabel = formatMessage({
      id: this.getI18nID('actionButtons.cancel')
    });
    const cancelButton = (
      <Button
        label={cancelLabel}
        variant="neutral"
        onClick={this.closeModal.bind(this)}
      />
    );

    /**
     * Select
     */
    const selectLabel = formatMessage({
      id: this.getI18nID(`actionButtons.select`)
    });
    const selectButton = (
      <Button
        label={selectLabel}
        disabled={!this.props.modals[this.modalName]?.data?.selectedAsset}
        variant="brand"
        onClick={this.handleSelect.bind(this)}
      />
    );

    return (
      <div className="footer-button-actions">
        {cancelButton}
        {selectButton}
      </div>
    );
  }

  getI18nID(suffix) {
    return `components.ecs.contentBuilderModal.${suffix}`;
  }

  closeModal() {
    this.props.actions.clearContentBuilderSearch();
    this.props.actions.closeModal(this.modalName);
  }

  render() {
    const { formatMessage } = this.props.intl;
    const isOpen = this.props.modals[this.modalName]?.isOpen;
    const modalTitle = formatMessage({
      id: this.getI18nID('title')
    });

    if (!isOpen) {
      return null;
    }

    return (
      <Modal
        heading={modalTitle}
        footer={this.renderFooter()}
        onRequestClose={this.closeModal.bind(this)}
        dismissOnClickOutside={false}
        disableClose={true}
        isOpen={isOpen || false}
      >
        {this.renderModal()}
      </Modal>
    );
  }
}

ContentBuilderModal.propTypes = {
  actions: PropTypes.object.isRequired,
  contentBuilder: PropTypes.object.isRequired,
  modals: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(ContentBuilderModal);
